import PropTypes from 'prop-types';
import FacetCheckboxes from '../attributes/checkboxes/facet_checkboxes';
import FacetCheckbox from '../attributes/checkboxes/facet_checkbox';

const FacetVideoTypes = ({ context, items, showMore, isChildList }) => {
  const attributes = [];
  items.forEach((item) => {
    attributes.push(
      <FacetCheckbox
        context={context}
        facet={item}
        showMore={showMore}
        key={item.id}
        hideCount={true}
      />
    );
  });

  return (
    <FacetCheckboxes context={context} items={[]} isChildList={isChildList}>
      {attributes}
    </FacetCheckboxes>
  );
};

FacetVideoTypes.propTypes = {
  context: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  showMore: PropTypes.bool,
  isChildList: PropTypes.bool
};

export default FacetVideoTypes;
